import {Card, Row, Col, Divider} from 'antd'
import React from 'react'

// Utility to group by broker
const GroupPoliciesByBrokerUtil = data => {
  const grouped = {}
  data.forEach(item => {
    const brokerId = item?.policydetail?.createdby
    if (!grouped[brokerId]) {
      grouped[brokerId] = {
        broker: item.brokerDbDetail,
        policies: [],
      }
    }
    grouped[brokerId].policies.push(item)
  })
  return Object.values(grouped)
}

const GroupPoliciesByBroker = ({data}) => {
  if (!data || !data.length) return null

  return (
    <>
      {GroupPoliciesByBrokerUtil(data).map((group, groupIndex) => {
        // Calculate totals for this broker group
        const totals = group.policies.reduce(
          (acc, ele) => {
            const pd = ele.policydetail || {}
            const pay = ele.payment_detail || {}
            acc.totalPremium += Number(pd.totalannualpremium) || 0
            acc.totalStampDuty += Number(pd.stampdutyannualpremium) || 0
            acc.governmentLevy += Number(pay.government_levy) || 0
            acc.grandTotal = acc.totalPremium + acc.totalStampDuty + acc.governmentLevy;
            return acc
          },
          {
            totalPremium: 0,
            totalStampDuty: 0,
            governmentLevy: 0,
            grandTotal: 0,
          },
        )

        return (
          <div key={groupIndex}>
            {group.policies.map((ele, i) => (
              <Card
                key={i}
                title={
                  <span
                    style={{
                      fontWeight: 'bold',
                      fontSize: '16px',
                      color: '#1890ff',
                    }}>
                    {`Policy ${i + 1}`}
                  </span>
                }
                style={{marginBottom: '20px', background: '#fafafa'}}
                headStyle={{fontWeight: 'bold', fontSize: '16px'}}>
                {/* Policy Detail */}
                <Row gutter={[16, 16]} style={{marginLeft: '10px'}}>
                  <Col xs={24} md={12}>
                    <h4 style={{fontWeight: '600', marginBottom: 10}}>
                      Policy Detail
                    </h4>
                    <ul style={{listStyle: 'none', padding: 0}}>
                      <li>Product Name: {ele?.policydetail?.productname}</li>
                      <li>Policy Number: {ele?.policydetail?.policynumber}</li>
                      <li>Start Date: {ele?.policydetail?.policystartdate}</li>
                      <li>
                        Expiry Date: {ele?.policydetail?.policyexpirytdate}
                      </li>
                      <li>
                        Total Sum Insured: {ele?.policydetail?.totalSumInsured}
                      </li>
                      <li>Amount: {ele?.policydetail?.amountPaid}</li>
                      <li>Policy Status: {ele?.policydetail?.policystatus}</li>
                    </ul>
                  </Col>
                  <Col xs={24} md={12}>
                    <h4 style={{fontWeight: '600', marginBottom: 10}}>
                      Premium Detail
                    </h4>
                    <ul style={{listStyle: 'none', padding: 0}}>
                      <li>Premium: {ele?.policydetail?.totalannualpremium}</li>
                      <li>
                        Stamp Duty: {ele?.policydetail?.stampdutyannualpremium}
                      </li>
                    </ul>
                  </Col>
                </Row>

                {/* Payment Detail */}
                <Divider />
                <h4
                  style={{
                    fontWeight: '600',
                    marginBottom: 10,
                    marginLeft: '10px',
                  }}>
                  Payment Detail
                </h4>
                <Row gutter={[16, 16]} style={{marginLeft: '10px'}}>
                  <Col xs={24} md={12}>
                    <ul style={{listStyle: 'none', padding: 0}}>
                      <li>
                        Payment Status: {ele?.payment_detail?.payment_status}
                      </li>
                      <li>
                        Transaction Id: {ele?.payment_detail?.transaction_ref}
                      </li>
                      <li>Payment Type: {ele?.payment_detail?.payment_type}</li>
                      <li>Amount: {ele?.payment_detail?.payment_amount}</li>
                      <li>Premium: {ele?.payment_detail?.premium}</li>
                      <li>
                        Balance Due:{' '}
                        {Number(ele?.payment_detail?.premium) -
                          Number(ele?.payment_detail?.payment_amount)}
                      </li>
                    </ul>
                  </Col>
                </Row>
              </Card>
            ))}

            {/* Totals per Broker Group */}
            <Card
              type="inner"
              title="Totals for Policies"
              style={{marginBottom: '20px', background: '#f0f5ff'}}>
              <ul style={{listStyle: 'none', padding: 0}}>
                <li>
                  <b>Total Premium:</b> {totals.totalPremium.toFixed(2)}
                </li>
                <li>
                  <b>Total Stamp Duty:</b> {totals.totalStampDuty.toFixed(2)}
                </li>
                <li>
                  <b>Government Levy:</b> {totals.governmentLevy.toFixed(2)}
                </li>
                <li>
                  <b>Grand Total:</b>{' '}
                  {totals.grandTotal.toFixed(2)}
                </li>
              </ul>
            </Card>

            {/* Broker Details - Only Once Per Group */}
            <Card
              type="inner"
              title="Broker Detail"
              style={{marginBottom: '30px'}}>
              <Row gutter={[16, 16]} style={{marginLeft: '10px'}}>
                <Col xs={24} md={12}>
                  <ul style={{listStyle: 'none', padding: 0}}>
                    <li>Name: {group.broker?.accountHolderName}</li>
                    <li>Firm Name: {group.broker?.firmName}</li>
                  </ul>
                  <h5 style={{margin: '10px 0 5px', fontWeight: '600'}}>
                    Bank Detail
                  </h5>
                  <ul style={{listStyle: 'none', padding: 0}}>
                    <li>Account Number: {group.broker?.accountNumber}</li>
                    <li>Bank Name: {group.broker?.bankName}</li>
                    <li>SWIFT/BIC: {group.broker?.ifsc}</li>
                    <li>Bank Address: {group.broker?.bankAddress}</li>
                  </ul>
                </Col>
                <Col xs={24} md={12}>
                  <h5 style={{margin: '10px 0 5px', fontWeight: '600'}}>
                    Address
                  </h5>
                  <ul style={{listStyle: 'none', padding: 0}}>
                    <li>
                      Address: {group.broker?.addressLine1}{' '}
                      {group.broker?.addressLine2}
                    </li>
                    <li>City: {group.broker?.city}</li>
                    <li>State: {group.broker?.state}</li>
                  </ul>
                </Col>
              </Row>
            </Card>
          </div>
        )
      })}
    </>
  )
}

export default GroupPoliciesByBroker
